<template>
<div>
 <div class="loading" v-if="loading">
<div class="loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
    </div>
  <div v-if="fetch">
     <div class=" mb-signin-bac" style="background-size: cover; background-position:  center left; height:100vh">
      <nav class="navbar  " style="background-color:rgba() ;">
 <router-link class="navbar-brand " to="/"  >
    <img src='../../../static/img/logo/Logo2.jpeg' width="50" height="50" alt="eshops-logo">
  
  </router-link>
  <div>
     <router-link to="/" class="text-info mr-1 m-link">Home</router-link>
  <!-- <router-link  :to="{name: 'startstore'}" class=" text-white m-link">Start Store</router-link> -->
  
  </div>
</nav>
  <div style="background-color:rgba(0, 0,0, 0.0) ;" class=" " >
    <div class="col-sm-8 col-md-4 m-auto " >
      <h3 class="m-auto text-center pt-5 pb-2" style="color:#E94DE9">Sign in</h3>
       <b-modal v-model="modalShow" centered ok-only class="text-center text-info">
      Please Enter Email!
    </b-modal>
    <b-modal v-model="modalShow2" centered class="text-center text-info">
      Password Reset Email is Sent to Your Email!
    </b-modal>
    
       <el-form :model="ruleForm3" status-icon ref="ruleForm3" label-width="120px" :label-position="labelPosition" size="medium" style="border: 1px solid #e2e2e2; border-radius:5px; background-color:#fff; padding:20px;">
     
    <el-form-item
        prop="email"
        label="Email"
        :rules="[
      { required: true, message: 'Please input email address', trigger: 'blur' },
      { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }
    ]"
    >
    <el-input type="email" v-model="ruleForm3.email"></el-input>
  
  </el-form-item>

  <el-form-item label="Password" prop="pass"
    :rules="[
      { required: true, message: 'Please input password', trigger: 'blur' }
    ]">
    <el-input type="password" v-model="ruleForm3.pass" auto-complete="off"></el-input>
  </el-form-item>
      <p><span class="pass text-danger pb-2" @click="respsw()">Forgot Password?</span> </p>
  <el-form-item class="pt-3">
    <el-button type="primary" @click="signin('ruleForm3')">Sign in</el-button>
    <el-button @click="resetForm('ruleForm3')">Reset</el-button>
  </el-form-item>
 
    </el-form>

 </div>
  </div>
 </div>
  </div>
</div>
</template>

<script>
import db from "../../config/FirebaseInit";
import firebase from 'firebase/app';;
//import dataUrl from '../../data/dataUrl'
  export default {
      name:"signin",
    data() {
      
      return {
        ruleForm3: {
          
          email:'',
          pass: '',
          prvroute:''
         
        },
        loading: false,
        fetch: true,
        dataUrl:'',
        modalShow: false,
        modalShow2: false,
        labelPosition: "top",
      };
    },

   beforeRouteEnter (to, from, next) {
  //     // this.prvroute = from
  //     //console.log(from.fullPath)
  //     if(firebase.auth().currentUser){
  //     // if(firebase.auth().currentUser.displayName != 'shop owner'){
  //        setTimeout(() => {
  //       next()
  //     },100)
  //     //} 
  //     }
      
     setTimeout(() => {
        next(vm => {
          vm.prvroute = from.fullPath
        })
      },200)
     
  },
  created(){
     //this.dataUrl = dataUrl
  },
    methods: {
      respsw(){
        if(this.ruleForm3.email == ''){
          this.modalShow = true
        }else{
          var auth = firebase.auth();
          var emailAddress = this.ruleForm3.email

          auth.sendPasswordResetEmail(emailAddress).then(() => {
            // Email sent.
            this.modalShow2 = true
          }).catch(function(error) {
            // An error happened.
          })
        }
        },
      signin(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
             this.fetch = false
              this.loading = true
            firebase.auth().signInWithEmailAndPassword(this.ruleForm3.email, this.ruleForm3.pass)
            .then(user => {
             
              //console.log(user)
              // if(firebase.auth().currentUser.displayName == 'shop owner'){
              //   this.$router.push('/admin')
              //  // alert(`signin admin ${user.email}` )
              // }else{
                if(this.prvroute == '/' || this.prvroute == '/startstore' || this.prvroute == '/termsofuse' || this.prvroute == 'privacypolicy' || this.prvroute == 'about'){
                  if(firebase.auth().currentUser.displayName == 'shop owner'){
                    this.$router.push('/admin')
                  // alert(`signin admin ${user.email}` )
                  }else if(firebase.auth().currentUser.displayName == 'starterplan shop owner'){
                    this.$router.push('/admin')
                  }else if(firebase.auth().currentUser.displayName == 'page owner'){
                    this.$router.push('/admin-services')
               // alert(`signin user ${user.email}`)
                  }else if(firebase.auth().currentUser.displayName == null){
                    this.$router.push('/myaccount')
               // alert(`signin user ${user.email}`)
                  }
                }else{
                   this.$router.push(this.prvroute)
               // alert(`signin user ${user.email}`)
                }
              //}
            })
            .catch( err => {
               this.fetch = true
              this.loading = false
              //console.log(err)
                alert(err)
            })
          } else {
            //console.log('error submit!!')
            return false
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      }
    }
  }
</script>

<style scoped>
@import url('~@/assets/main/css/loading.css');
  .pass{
    cursor: pointer;
    
  }
  @media (max-width: 767px){
	  .mb-signin-bac {
		  /* background-image:url(../../../static/img/key-2114046_1920.jpg); 
      background-size: cover !important; 
      background-position: 75% 50%!important;
       height:100vh;
       background-repeat: no-repeat; */
	  }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/Signin.vue